import { Link } from "react-router-dom";
import { SUBBRANDS } from "../data/content";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";
import logo from "../assets/wtei-full-logo.png";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative bg-[#050505] border-t border-white/10 pt-20 md:pt-28 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <img src={logo} alt="WTEI — World Travel Excellence Institute" className="h-24 w-auto rounded-xl bg-white shrink-0" />
              <h3 className="font-heading text-2xl md:text-3xl leading-tight text-wtei-text">
                World Travel <span className="text-wtei-primary">Excellence</span> Institute
              </h3>
            </div>
            <p className="font-body text-wtei-secondary text-base leading-relaxed max-w-md font-light">
              Advancing excellence in global travel and tourism through education, quality certification, research, innovation, and international collaboration.
            </p>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="text-xs uppercase tracking-[0.3em] text-wtei-primary mb-6">Our Brands</p>
            <ul className="space-y-4">
              {SUBBRANDS.map((b) => (
                <li key={b.id}>
                  <Link
                    data-testid={`footer-brand-${b.id}`}
                    to={`/brand/${b.slug}`}
                    className="text-wtei-text/80 hover:text-wtei-primary transition-colors text-sm uppercase tracking-wider"
                  >
                    {b.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-wtei-primary mb-6">Connect</p>
            <ul className="space-y-4 font-light">
              <li className="flex items-start gap-3 text-wtei-secondary text-sm">
                <Mail strokeWidth={1} size={18} className="text-wtei-primary mt-0.5 shrink-0" />
                <a data-testid="footer-email" href="mailto:info@wtei.org" className="hover:text-wtei-primary transition-colors">info@wtei.org</a>
              </li>
            </ul>
            <div className="flex flex-col gap-3 mt-6">
              {SUBBRANDS.map((b) => (
                <a
                  key={b.id}
                  data-testid={`footer-extlink-${b.id}`}
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-xs text-wtei-secondary hover:text-wtei-primary transition-colors"
                >
                  {b.urlLabel} <ArrowUpRight strokeWidth={1} size={14} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-wtei-secondary tracking-wider">
            © {new Date().getFullYear()} World Travel Excellence Institute. All rights reserved.
          </p>
          <p className="text-xs text-wtei-secondary/60 tracking-[0.2em] uppercase">Setting the benchmark for travel excellence</p>
        </div>
      </div>

      <div className="pointer-events-none absolute -bottom-16 left-1/2 -translate-x-1/2 font-heading text-[18vw] leading-none text-white/[0.025] select-none whitespace-nowrap">
        WTEI
      </div>
    </footer>
  );
};
